import type { ReactNode } from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';

import AppLogos from './AppLogos/AppLogos';
import Header from './Header/Header';

const logosRowStyle = xcss({
  width: '100%',
});

interface HeadlineProps {
  icon?: ReactNode;
  product?: string;
  agentName?: string;
  agentDescription?: string;
}

const Headline = ({
  icon,
  product,
  agentName,
  agentDescription,
}: HeadlineProps) => {
  return (
    <Flex direction="column" gap="space.250">
      <Box xcss={logosRowStyle}>
        <AppLogos icon={icon} />
      </Box>
      <Header
        product={product}
        agentName={agentName}
        agentDescription={agentDescription}
      />
    </Flex>
  );
};

export default Headline;
